import React from "react";
import * as styles from "../styles/holding.module.css";
import logo from "../images/logo_white_bg.png";
import Seo from "./Seo";

const HoldingPage = () => (
  <>
    <div className={styles.page}>
      <div className={styles.card}>
        <img src={logo} alt="Danby Design logo" className={styles.logo} loading="lazy" />
        <p className={styles.heading}>We're refreshing things.</p>
        <p className={styles.body}>
          The new Danby Design site is on the way. Check in again soon!
        </p>
      </div>
      <div className={styles.glow} aria-hidden="true" />
    </div>
    <Seo
      title="Danby Design | Holding page"
      description="Danby Design is refreshing its site."
      pathname="/"
    />
  </>
);

export default HoldingPage;
